module.exports = __webpack_public_path__ + "static/media/chats.b7fd4809.svg";